import "./popupLayout.scss";
import { ReactComponent as Exit } from "../../../../assets/exitIcon.svg";

export default function PopupLayout(props: {
  children?: any;
  buttonText?: string;
  ttle?: string;
  onSubmit?: () => void;
  onClickClose?: () => void;
  maxWidth?: string;
}) {
  return (
    <div className={"popup-background"}>
      <div className="popup-content" style={{ maxWidth: props.maxWidth }}>
        <div className="popup-title">
          <div>{props.ttle}</div>
          <Exit
            className="exit-icon"
            height={20}
            width={20}
            onClick={props.onClickClose}
            stroke={"black"}
          />
        </div>
        <div style={{ width: "100%", overflow: "auto" }}>{props.children}</div>
      </div>
    </div>
  );
}
